/**
 * @param {import("../../../utils/router/Router").default} router
 */
export default function (router) {
  router.group(
    {
      path: "/alfred/auth",
    },
    (router) => {
      router.push({
        id: "@api/auth@me",
        path: "/me",
      });

      router.push({
        id: "@api/auth@login",
        path: "/login",
      });
    },
  );
}
